import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "timeline"
}
const _hoisted_2 = { class: "timeline-item__icon" }
const _hoisted_3 = {
  key: 0,
  src: "/ressources/logged/img/gocardless/gocardless.svg",
  alt: "GoCardless icon"
}
const _hoisted_4 = { class: "timeline-item__content" }
const _hoisted_5 = { class: "timeline-item__main" }
const _hoisted_6 = { class: "typographies-paragraph-medium-bold timeline-item__title" }
const _hoisted_7 = { class: "colors-common-text-standard-caption timeline-item__label" }

import { TimelineItem } from 'vcomponents/common/timeline/Timeline.type';
import TimelineLoader from 'vcomponents/common/timeline/TimelineLoader.vue';
import { formatDateLabel } from 'Helpers/dateHelper';

interface Props {
    isLoading: boolean
    items: TimelineItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Timeline',
  props: {
    isLoading: { type: Boolean },
    items: {}
  },
  setup(__props: any) {



const mappingColorIcons: Record<string, CompassEnums.ColoredIconColorType> = {
    'success-circle': CompassEnums.ColoredIconColorType.GREEN,
    'alert-circle': CompassEnums.ColoredIconColorType.RED,
    'warning': CompassEnums.ColoredIconColorType.ORANGE,
    'reply': CompassEnums.ColoredIconColorType.ORANGE,
    'plus': CompassEnums.ColoredIconColorType.TEAL,
    'reload': CompassEnums.ColoredIconColorType.TEAL,
    'info-circle': CompassEnums.ColoredIconColorType.TEAL,
    'default': CompassEnums.ColoredIconColorType.GRAY,
};

function getIconColor(icon: string, isFirstItem: boolean): string
{
    if (isFirstItem) {
       return mappingColorIcons[icon] || mappingColorIcons['default'];
    }

    return mappingColorIcons['default'];
}

return (_ctx: any,_cache: any) => {
  const _component_CompassColoredIcon = _resolveComponent("CompassColoredIcon")!
  const _component_CompassPill = _resolveComponent("CompassPill")!

  return (__props.isLoading)
    ? (_openBlock(), _createBlock(TimelineLoader, {
        key: 0,
        nbItems: 5
      }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "timeline-item"
          }, [
            _createElementVNode("div", _hoisted_2, [
              (item.icon === 'gocardless')
                ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                : (_openBlock(), _createBlock(_component_CompassColoredIcon, {
                    key: 1,
                    icon: item.icon,
                    color: getIconColor(item.icon, index === 0),
                    size: _ctx.CompassEnums.ColoredIconSize.LARGE
                  }, null, 8 /* PROPS */, ["icon", "color", "size"]))
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(item.title), 1 /* TEXT */),
                (item.highlightedDate)
                  ? (_openBlock(), _createBlock(_component_CompassPill, {
                      key: 0,
                      variant: _ctx.CompassEnums.PillVariant.STROKED,
                      label: _unref(formatDateLabel)(item.highlightedDate),
                      size: _ctx.CompassEnums.PillSize.EXTRA_SMALL,
                      icon: "clock"
                    }, null, 8 /* PROPS */, ["variant", "label", "size"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(item.label), 1 /* TEXT */)
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
}
}

})